/*
 * Copyright (c) 2024-2025 Nodals AI Ltd
 * All rights reserved.
 */

declare const __LIB_VERSION__: string;

class Library {
  static readonly MAJOR_VERSON_PATTERN: string = '1.x.x';
  public static get name(): string {
    return 'prebid-rtd-engine';
  }
  public static get version(): string {
    return __LIB_VERSION__;
  }
}

export default Library;
